import { GroupInfo, IOption } from "../../../../types";

export const getAccountingGroupIdOptions = (
  groupIds: GroupInfo[],
): Array<IOption> => {
  const filteredGroupIds = groupIds.filter(
    (group: GroupInfo) => group.type === "ACCOUNTING_GROUP",
  );
  const groupIdOptions: Array<IOption> = filteredGroupIds.map(
    (group: GroupInfo) => ({
      label: group.name,
      value: group.groupId,
      isDisabled: false,
    }),
  );
  return groupIdOptions;
};